import React from 'react'
import { useNavigate } from 'react-router-dom'
import { M_Table } from 'src/M_Components'

const Transport = ({ roles, onCreateTab }) => {
    const navigate = useNavigate()

    const NewRoute = (url, label) => {
        // console.log(JSON.parse(sessionStorage.getItem('contextLine')).id)
        navigate(`${url}`)
        onCreateTab(url, label)
    }

    //! onClick para conseguir o id

    const lineContextMenuVoyage = [
        { separator: true },
        { label: 'Create Booking', command: () => NewRoute("go/createBooking", "Create Booking") },
    ]

    return (
        <M_Table entityName={'transport'} rolePermissions={roles} lineContext={lineContextMenuVoyage} />
    )
}

export default Transport